import React from 'react';
import FormField from '../FormField';

export default function DesenolvimentoRegionalDiagnostico() {
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção consolida as potencialidades do município, indicadores socioeconômicos finais e a síntese do diagnóstico municipal.</p>
      </div>

      <div className="mt-4">
        <FormField
          name="potencialidades_projetos_integracao"
          label="Potencialidades, projetos estratégicos e integração regional"
          type="textarea"
          placeholder="Descreva as principais potencialidades do município, projetos estratégicos em planejamento ou execução, formas de integração regional e parcerias existentes"
          helpText="Principais potencialidades, projetos estratégicos em planejamento ou execução, formas de integração regional e parcerias existentes"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          name="pib_per_capita"
          label="PIB per capita mais recente"
          type="currency"
          placeholder="Digite o PIB per capita"
          helpText="Informe o valor e o ano de referência"
        />

        <FormField
          name="empregos_formais"
          label="Número de empregos formais"
          type="numeric"
          thousandSeparator="."
          decimalSeparator=","
          placeholder="Digite o número de empregos formais"
          helpText="Informe o valor e o ano de referência"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          name="idhm"
          label="IDHM mais recente disponível"
          type="decimal3"
          placeholder="Digite o IDHM"
          helpText="Informe o valor e o ano de referência (0,000 a 1,000)"
          validation={{
            validate: (value) => {
              if (value === undefined || value === '') return true;
              return (value >= 0 && value <= 1) || 'O valor deve ser entre 0,000 e 1,000';
            }
          }}
        />

        <FormField
          name="receita_propria"
          label="Receita própria municipal"
          type="currency"
          placeholder="Digite a receita própria municipal"
          helpText="Informe o valor ou percentual e o ano de referência"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="desenvolvimento_regional_problemas"
          label="Principais problemas identificados"
          type="textarea"
          placeholder="Descreva os principais problemas identificados, considerando dependência econômica, baixa diversificação, limitações de infraestrutura e dificuldades de cooperação"
          helpText="Considere dependência econômica, baixa diversificação, limitações de infraestrutura e dificuldades de cooperação"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="desenvolvimento_regional_demandas"
          label="Demandas prioritárias identificadas"
          type="textarea"
          placeholder="Descreva as demandas prioritárias identificadas, considerando projetos prioritários, apoio técnico, investimentos e integração regional"
          helpText="Considere projetos prioritários, apoio técnico, investimentos e integração regional"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="diagnostico_sintese"
          label="Síntese do diagnóstico municipal"
          type="textarea"
          placeholder="Apresente a síntese do diagnóstico municipal, destacando os principais achados do levantamento"
          helpText="Síntese do diagnóstico municipal, destacando os principais achados do levantamento"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao10"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />

        <FormField
          name="links_acesso_secao10"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
